/** Static card data. Mirrors the shape of the vendored deck.js definitions. */
export const SUITS = [
    'land', 'flood', 'weather', 'flame', 'army', 'wizard', 'leader',
    'beast', 'weapon', 'artifact', 'wild',
    // Cursed Hoard
    'building', 'outsider', 'undead', 'cursed-item',
];
export const LOCALES = [
    'de', 'en', 'cz', 'es', 'fr', 'it', 'kr', 'pl', 'pt', 'ru', 'ua', 'zh', 'zh_TW',
];
